<template>
  <div class="of-login new-login">
    <div class="login-box clear-both">
      <div
        class="left"
        :style="{backgroundImage:`url(` + require(`@/assets/images/login-bg.jpg`) + `)`}"
      >
        <div
          class="of-logo"
          @click="goto('/')"
        >
          <!-- <span>赛事圈小程序后台</span> -->
        </div>
      </div>
      <div class="right">
        <div class="ant-pro-form-login-top  ">
          <div class="ant-pro-form-login-header "><span class="ant-pro-form-login-logo "><img
                alt="logo"
                src="../assets/images/logo.jpg"
              ></span><span class="ant-pro-form-login-title ">赛事圈平台</span></div>
          <div class="ant-pro-form-login-desc ">中国最具影响力的赛事平台</div>
        </div>
        <div class="login-container">
          <div class="login-content">
            <div
              v-for="(item, index) in loginHeader"
              :key="index"
              class="login-header"
            >
              <ul
                v-if="setLoginHeader(index)"
                class="clear-both"
              >
                <li
                  v-for="(titem, tindex) in item"
                  :key="tindex"
                >
                  <font
                    :class="{'active': titem.id === loginActive}"
                    @click="loginChange(titem.id)"
                  >
                    <span>{{ titem.name }}</span>
                  </font>
                </li>
              </ul>
            </div>
            <!-- 验证码登录 -->
            <div
              v-show="loginActive === '1'"
              class="login-item"
            >
              <el-form
                ref="mobileForm"
                :model="ruleForm"
                :rules="rules"
                class="login-form"
              >
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('mobile')"
                  prop="mobile"
                >
                  <el-input
                    v-model="ruleForm.mobile"
                    @focus="changeFocus('mobile')"
                    @blur="changeFocus()"
                  ></el-input>
                  <div class="form-placeholder">请输入手机号</div>
                </el-form-item>
                <!-- mobile -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('vfCode')"
                  prop="vfCode"
                >
                  <el-input
                    v-model="ruleForm.vfCode"
                    @focus="changeFocus('vfCode')"
                    @blur="changeFocus()"
                  >
                    <span
                      v-show="vfCodeTimeout <= 0"
                      slot="append"
                      class="inline-btn"
                      @click="getVerifyCode('mobile')"
                    >点击获取验证码</span>
                    <span
                      v-show="vfCodeTimeout > 0"
                      slot="append"
                      class="inline-btn"
                    >{{ vfCodeTimeout }}秒后重试</span>
                  </el-input>
                  <div class="form-placeholder">请输入验证码</div>
                </el-form-item>
                <!-- vfCode -->
                <div class="login-item-group">
                  <div class="tablelayout item-info">
                    <div class="tablelayout-l">
                      <el-checkbox-group v-model="ruleForm.is_longtime">
                        <el-checkbox
                          label="7天免登录"
                          name="is_longtime"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="tablelayout-s">
                      <span
                        class="item-btn"
                        @click="loginActive = '3'"
                      >忘记密码？</span>
                    </div>
                  </div>
                </div>
                <!-- group -->
                <el-button
                  type="primary login-form-btn"
                  @click="loginByMobile()"
                >登 录</el-button>
                <!-- submit -->
                <div class="login-item-group no-margin">
                  <div class="item-info text-center">
                    <p>
                      还没有账号？
                      <span
                        class="item-link"
                        @click="loginActive = '4'"
                      >免费注册</span>
                    </p>
                  </div>
                </div>
                <!-- group -->
                <dl class="login-item-other">
                  <dt>
                    <span>社交账号登录</span>
                  </dt>
                  <dd>
                    <a @click="jumpto('/weixin/web/userLogin?state=login')">
                      <i class="fab fa-weixin"></i>
                    </a>
                  </dd>
                </dl>
                <!-- other -->
              </el-form>
            </div>
            <!-- 密码登录 -->
            <div
              v-show="loginActive === '2'"
              class="login-item"
            >
              <el-form
                ref="emailForm"
                :model="ruleForm"
                :rules="rules"
                class="login-form"
              >
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('mobile_email')"
                  prop="mobile_email"
                >
                  <span
                    role="img"
                    aria-label="user"
                    class="anticon anticon-user"
                  ><svg
                      viewBox="64 64 896 896"
                      focusable="false"
                      data-icon="user"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"></path>
                    </svg></span>
                  <el-input
                    placeholder="用户名"
                    v-model="ruleForm.mobile_email"
                    @focus="changeFocus('mobile_email')"
                    @blur="changeFocus()"
                  ></el-input>
                  <!-- <div class="form-placeholder">请输入账号</div> -->
                </el-form-item>
                <!-- email -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('password')"
                  prop="password"
                >
                  <span
                    role="img"
                    aria-label="lock"
                    class="anticon anticon-lock"
                  ><svg
                      viewBox="64 64 896 896"
                      focusable="false"
                      data-icon="lock"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"></path>
                    </svg></span>
                  <el-input
                    placeholder="密码"
                    v-model="ruleForm.password"
                    show-password
                    @focus="changeFocus('password')"
                    @blur="changeFocus()"
                  >
                  </el-input>
                  <!-- <div class="form-placeholder">请输入密码</div> -->
                </el-form-item>
                <!-- password -->
                <div class="login-item-group">
                  <div class="tablelayout item-info">
                    <div class="tablelayout-l eig-automatic">
                      <el-checkbox-group v-model="ruleForm.is_longtime">
                        <el-checkbox
                          label="自动登录"
                          name="is_longtime"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <span class="item-btn">忘记密码？</span>
                    </div>
                  </div>
                </div>
                <!-- group -->
                <el-button
                  type="primary login-form-btn"
                  @click="LoginByAccount()"
                >登 录</el-button>
                <!-- submit -->
                <!-- <div class="login-item-group no-margin">
                  <div class="item-info text-center">
                    <p>
                      还没有账号？
                      <span
                        class="item-link"
                        @click="loginActive = '4'"
                      >免费注册</span>
                    </p>
                  </div>
                </div> -->
                <!-- group -->
                <!-- <dl class="login-item-other">
                  <dt>
                    <span>社交账号登录</span>
                  </dt>
                  <dd>
                    <a @click="jumpto('/weixin/web/userLogin?state=login')">
                      <i class="fab fa-weixin"></i>
                    </a>
                  </dd>
                </dl> -->
                <!-- other -->
              </el-form>
            </div>
            <!-- 重置密码 -->
            <div
              v-show="loginActive === '3'"
              class="login-item"
            >
              <el-form
                ref="resetPasswordForm"
                :model="ruleForm"
                :rules="rules"
                class="login-form"
              >
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('mobile_email')"
                  prop="mobile_email"
                >
                  <el-input
                    v-model="ruleForm.mobile_email"
                    @focus="changeFocus('mobile_email')"
                    @blur="changeFocus()"
                  ></el-input>
                  <div class="form-placeholder">请输入手机号/邮箱</div>
                </el-form-item>
                <!-- mobile -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('vfCode')"
                  prop="vfCode"
                >
                  <el-input
                    v-model="ruleForm.vfCode"
                    @focus="changeFocus('vfCode')"
                    @blur="changeFocus()"
                  >
                    <span
                      v-show="vfCodeTimeout <= 0"
                      slot="append"
                      class="inline-btn"
                      @click="getVerifyCode()"
                    >点击获取验证码</span>
                    <span
                      v-show="vfCodeTimeout > 0"
                      slot="append"
                      class="inline-btn"
                    >{{ vfCodeTimeout }}秒后重试</span>
                  </el-input>
                  <div class="form-placeholder">请输入验证码</div>
                </el-form-item>
                <!-- vfCode -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('password')"
                  prop="password"
                >
                  <el-input
                    v-model="ruleForm.password"
                    show-password
                    @focus="changeFocus('password')"
                    @blur="changeFocus()"
                  >
                  </el-input>
                  <div class="form-placeholder">请输入密码</div>
                </el-form-item>
                <!-- password -->
                <el-button
                  type="primary login-form-btn has-margin"
                  @click="resetPassword"
                >完 成</el-button>
                <!-- submit -->
                <div class="login-item-group no-margin">
                  <div class="item-info text-center">
                    <p>
                      <span
                        class="item-link"
                        @click="loginActive = '2'"
                      >返回登录</span>
                    </p>
                  </div>
                </div>
                <!-- group -->
              </el-form>
            </div>
            <!-- 注册 -->
            <div
              v-show="loginActive === '4'"
              class="login-item"
            >
              <el-form
                ref="rMobileForm"
                :model="ruleForm"
                :rules="rules"
                class="login-form"
              >
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('mobile')"
                  prop="mobile"
                >
                  <el-input
                    v-model="ruleForm.mobile"
                    @focus="changeFocus('mobile')"
                    @blur="changeFocus()"
                  ></el-input>
                  <div class="form-placeholder">请输入手机号</div>
                </el-form-item>
                <!-- mobile -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('vfCode')"
                  prop="vfCode"
                >
                  <el-input
                    v-model="ruleForm.vfCode"
                    @focus="changeFocus('vfCode')"
                    @blur="changeFocus()"
                  >
                    <span
                      v-show="vfCodeTimeout <= 0"
                      slot="append"
                      class="inline-btn"
                      @click="getVerifyCode('mobile')"
                    >点击获取验证码</span>
                    <span
                      v-show="vfCodeTimeout > 0"
                      slot="append"
                      class="inline-btn"
                    >{{ vfCodeTimeout }}秒后重试</span>
                  </el-input>
                  <div class="form-placeholder">请输入验证码</div>
                </el-form-item>
                <!-- vfCode -->
                <!-- group -->
                <el-button
                  type="primary login-form-btn"
                  @click="registerByMobile()"
                >注 册</el-button>
                <!-- submit -->
                <div class="login-item-group no-margin">
                  <div class="item-info text-center">
                    <p>
                      已有账号？
                      <span
                        class="item-link"
                        @click="loginActive = '1'"
                      >立即登录</span>
                    </p>
                  </div>
                </div>
                <!-- group -->
              </el-form>
            </div>
            <!-- 绑定手机号 -->
            <div
              v-show="loginActive === '5'"
              class="login-item"
            >
              <el-form
                ref="bMobileForm"
                :model="ruleForm"
                :rules="rules"
                class="login-form"
              >
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('mobile')"
                  prop="mobile"
                >
                  <el-input
                    v-model="ruleForm.mobile"
                    @focus="changeFocus('mobile')"
                    @blur="changeFocus()"
                  ></el-input>
                  <div class="form-placeholder">请输入手机号</div>
                </el-form-item>
                <!-- mobile -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('vfCode')"
                  prop="vfCode"
                >
                  <el-input
                    v-model="ruleForm.vfCode"
                    @focus="changeFocus('vfCode')"
                    @blur="changeFocus()"
                  >
                    <span
                      v-show="vfCodeTimeout <= 0"
                      slot="append"
                      class="inline-btn"
                      @click="getVerifyCode('mobile')"
                    >点击获取验证码</span>
                    <span
                      v-show="vfCodeTimeout > 0"
                      slot="append"
                      class="inline-btn"
                    >{{ vfCodeTimeout }}秒后重试</span>
                  </el-input>
                  <div class="form-placeholder">请输入验证码</div>
                </el-form-item>
                <!-- vfCode -->
                <el-form-item
                  class="login-item-group"
                  prop="checked"
                >
                  <div class="tablelayout item-info">
                    <div class="tablelayout-l">
                      <el-checkbox-group v-model="ruleForm.checked">
                        <el-checkbox>
                          我已接受并同意
                          <el-link
                            type="primary"
                            class="agree"
                            @click="showAgreement()"
                          >《AladdinGO用户使用协议》</el-link>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </el-form-item>
                <!-- group -->
                <el-button
                  type="primary login-form-btn"
                  @click="bindWeixin"
                >快 速 绑 定</el-button>
                <!-- submit -->
                <div class="login-item-group">
                  <div class="tablelayout item-info">
                    <div class="tablelayout-l">
                      <span
                        class="item-link"
                        @click="loginActive = '1'"
                      >返回登录</span>
                    </div>
                    <div class="tablelayout-s">
                      <span
                        class="item-btn"
                        @click="loginActive = '6'"
                      >绑定已有账号</span>
                    </div>
                  </div>
                </div>
                <!-- group -->
              </el-form>
            </div>
            <!-- 绑定已有账号 -->
            <div
              v-show="loginActive === '6'"
              class="login-item"
            >
              <el-form
                ref="bEmailForm"
                :model="ruleForm"
                :rules="rules"
                class="login-form"
              >
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('mobile_email')"
                  prop="mobile_email"
                >
                  <el-input
                    v-model="ruleForm.mobile_email"
                    @focus="changeFocus('mobile_email')"
                    @blur="changeFocus()"
                  ></el-input>
                  <div class="form-placeholder">请输入手机号/邮箱</div>
                </el-form-item>
                <!-- email -->
                <el-form-item
                  class="login-form-group"
                  :class="setFormClass('password')"
                  prop="password"
                >
                  <el-input
                    v-model="ruleForm.password"
                    show-password
                    @focus="changeFocus('password')"
                    @blur="changeFocus()"
                  >
                  </el-input>
                  <div class="form-placeholder">请输入密码</div>
                </el-form-item>
                <!-- password -->
                <el-form-item
                  class="login-item-group"
                  prop="checked"
                >
                  <div class="tablelayout item-info">
                    <div class="tablelayout-l">
                      <el-checkbox-group v-model="ruleForm.checked">
                        <el-checkbox>
                          我已接受并同意
                          <el-link
                            type="primary"
                            class="agree"
                            @click="showAgreement()"
                          >《AladdinGO用户使用协议》</el-link>
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </el-form-item>
                <!-- group -->
                <el-button
                  type="primary login-form-btn"
                  @click="bindWeixin"
                >快 速 绑 定</el-button>
                <!-- submit -->
                <div class="login-item-group">
                  <div class="tablelayout item-info">
                    <div class="tablelayout-l">
                      <span
                        class="item-link"
                        @click="loginActive = '2'"
                      >返回登录</span>
                    </div>
                    <div class="tablelayout-s">
                      <span
                        class="item-btn"
                        @click="loginActive = '5'"
                      >绑定手机号</span>
                    </div>
                  </div>
                </div>
                <!-- group -->
              </el-form>
            </div>
          </div>

        </div>
      </div>
      <footer
        class="ant-layout-footer css-ph9edi"
        style="padding: 0px; background: none;"
      >
        <div class="ant-pro-global-footer">
          <div class="ant-pro-global-footer-copyright "><span
              role="img"
              aria-label="copyright"
              class="anticon anticon-copyright"
            ><svg
                viewBox="64 64 896 896"
                focusable="false"
                data-icon="copyright"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"></path>
              </svg></span> <a href="https://beian.miit.gov.cn/#/Integrated/index"> 2024 浙ICP备2021006776号-2</a></div>
        </div>
      </footer>
    </div>

  </div>

</template>

<script>
import { menuSelect } from "@/utils/utils";
export default {
  name: "LoginPanel",
  components: {},
  data() {
    const validateChecked = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请勾选同意即可注册"));
      } else {
        callback();
      }
    };
    var checkMobileNo = (rule, value, callback) => {
      value = this.trimLine(value);
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        if (this.loginActive === "4" || this.loginActive === "5") {
          if (this.rtimer) {
            clearTimeout(this.rtimer);
          }
          this.rtimer = setTimeout(() => {
            this.$http
              .post("/core/Login/CheckMobileRegister", { mobile: value })
              .then((resp) => {
                if (resp.code !== 0) {
                  callback(new Error("该手机号已注册"));
                } else {
                  callback();
                }
              });
          }, 300);
        } else {
          callback();
        }
      }
    };
    var checkMobileOrEmail = (rule, value, callback) => {
      value = this.trimLine(value);
      if (
        !/^1(3|4|5|6|7|8|9)\d{9}$/.test(value) &&
        !/(\w?)(\w+)(\w)(@\w+\.[a-z]+(\.[a-z]+)?)/.test(value)
      ) {
        callback(new Error("请输入正确的手机号/邮箱"));
      } else {
        callback();
      }
    };
    var checkVfCode = (rule, value, callback) => {
      value = this.trimLine(value);
      if (!/^\d{4}$/.test(value)) {
        callback(new Error("请输入4位数字"));
      } else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      value = this.trimLine(value);
      if (!/(\w?)(\w+)(\w)(@\w+\.[a-z]+(\.[a-z]+)?)/.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    var checkPasswod = (rule, value, callback) => {
      value = this.trimLine(value);
      // || value.length < 6 || value.length > 50
      if (value === "") {
        callback(new Error("密码是必填项！"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        mobile: "",
        mobile_email: "",
        vfCode: "",
        is_longtime: localStorage.getItem("is_longtime") === "true",
        checked: true,
        email: "",
        password: "",
      },
      rules: {
        mobile: [
          {
            validator: checkMobileNo,
            trigger: ["blur", "change"],
            required: true,
          },
        ],
        mobile_email: [
          {
            trigger: ["blur", "change"],
            message: "用户名是必填项！",
            required: true,
          },
        ],
        vfCode: [
          {
            validator: checkVfCode,
            trigger: ["blur", "change"],
            required: true,
          },
        ],
        checked: [
          {
            validator: validateChecked,
            trigger: ["blur", "change"],
            required: true,
          },
        ],
        email: [
          {
            validator: checkEmail,
            trigger: ["blur", "change"],
            required: true,
          },
        ],
        password: [
          {
            validator: checkPasswod,
            trigger: ["blur", "change"],
            required: true,
          },
        ],
      },
      formFocus: "",
      loginHeader: [
        // { name: "验证码登录", id: "1" },
        [{ name: "账户密码登录", id: "2" }],
        [{ name: "重置密码", id: "3" }],
        [{ name: "注册", id: "4" }],
        [{ name: "注册并绑定手机号", id: "5" }],
        [{ name: "绑定已有账号", id: "6" }],
      ],
      loginActive: "2",
      dialogAgreementVisible: false,
      vfCodeTimeout: 0,
    };
  },
  computed: {},
  watch: {
    "ruleForm.is_longtime": {
      handler(val) {
        localStorage.setItem("is_longtime", val);
      },
    },
    // loginActive (newVal) {
    //   if (newVal === '4') this.$router.push('/login/register')
    //   else if (newVal !== '5' && newVal !== '6') this.$router.push('/login/panel')
    //   this.ruleForm = {
    //     mobile: '',
    //     mobile_email: '',
    //     vfCode: '',
    //     is_longtime: false,
    //     checked: true,
    //     email: '',
    //     password: ''
    //   }
    //   this.vfCodeTimeout = 0
    //   this.$refs.mobileForm.clearValidate()
    //   this.$refs.rMobileForm.clearValidate()
    //   this.$refs.emailForm.clearValidate()
    //   this.$refs.resetPasswordForm.clearValidate()
    //   this.$refs.bMobileForm.clearValidate()
    //   this.$refs.bEmailForm.clearValidate()
    // }
  },
  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事
  },
  mounted() {
    if (this.localization) this.$router.push("/login/local");
    if (this.$route.path === "/login/register") this.loginActive = "4";
    if (this.$route.query.wxlogin === "nologin") {
      this.$message.warning("该微信未绑定，请先绑定账号再登录");
      this.loginActive = "5";
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handkeyCode, true); //关闭监听键盘按下事件
  },
  methods: {
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.LoginByAccount();
      }
    },
    // 跳转
    jumpto(path) {
      if (path) location.href = path;
    },
    // 选项改变
    loginChange(id) {
      if (id) this.loginActive = id;
    },
    // 设置标题
    setLoginHeader(index) {
      let isShow = false;
      this.loginHeader[index].forEach((tItem) => {
        if (tItem.id === this.loginActive) {
          isShow = true;
        }
      });
      return isShow;
    },
    // 设置表单样式
    setFormClass(form) {
      const formClass = {};
      if (form && this.formFocus === form) {
        formClass["form-focus"] = true;
      }
      if (form && this.ruleForm[form] && this.ruleForm[form].length > 0) {
        formClass["form-assigned"] = true;
      }
      return formClass;
    },
    // 焦点更改
    changeFocus(form) {
      let focusType = "";
      if (form) {
        focusType = form;
      }
      this.formFocus = focusType;
    },
    // 打开使用协议展示
    showAgreement() {
      this.ruleForm.checked = !this.ruleForm.checked;
      this.dialogAgreementVisible = true;
    },
    // 关闭使用协议展示
    closeAgreement() {
      this.dialogAgreementVisible = false;
    },
    // 获取验证码
    getVerifyCode(type) {
      var _this = this;
      var request = { type };
      var mobileRegex = /^1(3|4|5|6|7|8|9)\d{9}$/;
      var emailRegex = /(\w?)(\w+)(\w)(@\w+\.[a-z]+(\.[a-z]+)?)/;
      if (type === "mobile") {
        var value = _this.ruleForm.mobile;
        value = this.trimLine(value);
        if (!mobileRegex.test(value))
          return _this.$message.error("请输入正确的手机号");
        request.account = value;
      } else if (type === "email") {
        value = _this.ruleForm.email;
        value = this.trimLine(value);
        if (!emailRegex.test(value))
          return _this.$message.error("请输入正确的邮箱");
        request.account = value;
      } else {
        value = _this.ruleForm.mobile_email;
        value = this.trimLine(value);
        if (!mobileRegex.test(value) && !emailRegex.test(value))
          return _this.$message.error("请输入正确的手机号/邮箱");
        request.account = value;
      }
      _this.vfCodeTimeout = 60;
      _this.$http.post("/core/Login/GetVerifyCode", request).then((res) => {
        if (res && res.code === 0) {
          var timer = setInterval(() => {
            _this.vfCodeTimeout--;
            if (_this.vfCodeTimeout <= 0) clearInterval(timer);
          }, 1000);
          _this.ruleForm.vfCode = res.result;
        } else {
          _this.vfCodeTimeout = 0;
          _this.$message.error(res ? res.msg : "获取验证码错误，请稍后重试");
        }
      });
    },
    // 手机号登录
    loginByMobile() {
      var _this = this;
      this.$refs.mobileForm.validate((val) => {
        if (val) {
          console.log("loginByMobile");
        } else {
          _this.$message.error("请输入正确的手机号及验证码");
        }
      });
    },
    // 手机号注册
    registerByMobile() {
      var _this = this;
      this.$refs.rMobileForm.validate((val) => {
        if (val) {
          console.log("registerByMobile");
        } else {
          if (!_this.ruleForm.checked) {
            _this.$message.error("请勾选同意即可注册");
          } else {
            _this.$message.error("请输入正确的手机号及验证码");
          }
        }
      });
    },
    // 账号登录
    LoginByAccount() {
      var _this = this;
      this.$refs.emailForm.validate((val) => {
        if (val) {
          this.$http({
            method: "post",
            url: "/login",
            data: {
              username: this.ruleForm.mobile_email,
              password: this.ruleForm.password,
            },
          }).then((res) => {
            if (res.data.msg == "ok") {
              localStorage.setItem("eleToken", res.data.token);
              localStorage.setItem(
                "admins",
                JSON.stringify(res.data.admins[0])
              );
              if (res.data.admins[0].authority) {
                let authority = res.data.admins[0].authority;
                localStorage.setItem("authority", authority);
                this.$router.push({
                  path: menuSelect(
                    this.$store.state.menuList,
                    JSON.parse(authority)
                  ),
                });
              } else {
                this.$router.push({ path: "/index" });
              }
              let btnPermit = res.data.admins[0].btnPermit;
              if (btnPermit) {
                localStorage.setItem("btnPermit", btnPermit);
              }
            } else {
              this.$message.error("账号或密码错误");
            }
          });
        } else {
          _this.$message.error("请输入正确的账号和密码");
        }
      });
    },
    // 重置密码
    resetPassword() {
      var _this = this;
      this.$refs.resetPasswordForm.validate((val) => {
        if (val) {
          console.log("resetPassword");
        } else {
          _this.$message.error("请输入正确的手机号/邮箱及密码");
        }
      });
    },
    // 绑定微信
    bindWeixin() {
      var _this = this;
      var bindRef = _this.loginActive === "5" ? "bMobileForm" : "bEmailForm";
      var bindMsg =
        _this.loginActive === "5"
          ? "请输入正确的手机号及验证码"
          : "请输入正确的手机号/邮箱及密码";
      this.$refs[bindRef].validate((val) => {
        if (val) {
          console.log("bindWeixin");
        } else {
          _this.$message.error(bindMsg);
        }
      });
    },
    trimLine(str) {
      if (str) {
        str = str.replace(/(^\s*)|(\s*$)/g, "");
        if (str) {
          str = str.replace(/[\r\n]/g, "");
        }
      }
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
